import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PaymentHandlingComponent } from './core/payment-handling/payment-handling.component';

export const routes: Routes = [
    {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren:  () => import('./auth/account.module').then(m => m.AccountModule),
      },

      {
        path: "error",
        loadChildren: () => import('./shared/components/error/error.module').then(m => m.ErrorModule),
      },
    ],
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/main.module').then(m => m.MainModule),
  },
  {
    path: "payment-callback",
    component: PaymentHandlingComponent,
    title: "Payment Handling",
  },
  {
    path: "**",
    redirectTo: "error/404",
  },
];
